$(function () {
    JSON.parse(localStorage["__mycart"] || '[]')
        .forEach((value) => {
            $('.img-blk').find(`button[data-id="${value.id}"]`).closest('.img-blk').addClass('active')
            $('.img-blk').find(`button[data-id="${value.id}"]`).text('Added')
        });
    
    $('.my-cart-btn').myCart({
        classCartIcon: 'my-cart-icon',
        classCartBadge: 'my-cart-badge',
        affixCartIcon: true,
    });

    $('.my-cart-checkout').on('click', function() {
        $('.modal-body').children().hide().end().append($('#book-free-quote')).end();
        $('.form-wrapper').not(':has(*):not(:empty)').append($('#book-free-quote').clone());
        $('.form-wrapper').find('input[type="radio"]').removeAttr('id')
        $('.modal-footer').hide();
        $('#exampleModalLabel').text('Get Quote!!');
        $('#book-free-quote').show()
    });
    
    $('.my-cart-icon').on('click', function() {
        $('.modal-body').children().hide()
        $('#exampleModalLabel').text('My Cart');
        $('.modal-body').find('#book-free-quote').hide()
        $('#my-cart-table').show()
        $('.modal-footer').show()
    });

    $('.form').on('click', function (event) {
        event.preventDefault();
        $('.modal-footer').show();
    
        const $this = $(this);
        const $modal = $('.modal');
        const $modalBody = $('.modal-body');
        const $modalFooter = $('.modal-footer');
        const nextText = $this.closest('.img-blk').next('.wd-title').text();
    
        const $imgBlk = $this.closest('.img-blk');
        const $originalButton = $imgBlk.find('.my-cart-btn');
     
        $modalFooter.find('.my-cart-checkout').before($originalButton).show();
        $this.closest('.carousel, .img-blk').append($originalButton.clone());
    
        $modalBody.children().hide();
        $('#exampleModalLabel').text(nextText);
    
        const carouselId = 'productCarousel-' + Date.now();
    
        const $categoryBlock = $this.closest('.category-blk');
        const $allMediaLinks = $categoryBlock.find('.img-blk .form');
        const totalItems = $allMediaLinks.length;
    
        let carouselItems = '';
        let thumbnails = '';

        $('.carousel.slide video').each(function() {
            if (!this.paused) {
                originalPlayingVideo = this;
                this.pause();
            }
        });
    
        $allMediaLinks.each(function (index) {
            const isActive = index === $allMediaLinks.index($this) ? 'active' : '';
            const mediaSrc = $(this).attr('href') || $(this).find('source').attr('src');
            const thumbSrc = $(this).find('img').attr('src') || $(this).find('video').attr('poster') || '';

            const isVideo = /\.(mp4|webm|ogg)$/i.test(mediaSrc);
            const mediaHTML = isVideo
                ? `<video controls class="h-100 object-fit-cover d-flex modal-video" ><source src="${mediaSrc}" type="video/${mediaSrc.split('.').pop()}"></video>`
                : `<img src="${mediaSrc}" class="d-block w-100" alt="${nextText}">`;
    
            carouselItems += `
                <div class="carousel-item ${isActive}">
                    ${mediaHTML}
                </div>
            `;
    
            if (totalItems > 1) {
                const isVideo = $(this).find('video').length > 0;
                thumbnails += `
                    <div class="thumbnail-item mx-1 ${isActive}" data-bs-target="#${carouselId}" data-bs-slide-to="${index}">
                        <img src="${thumbSrc}" class="img-thumbnail ${isVideo ? 'has-video' : ''}" alt="Thumbnail ${index + 1}" style="width: 60px; height: 60px; object-fit: cover;">
                        ${isVideo ? '<div class="thumb-play-button"></div>' : ''}
                    </div>
                `;
            }
        });
    
        if (totalItems > 1) {
            thumbnails = `<div class="carousel-thumbnails d-flex justify-content-center mt-3">${thumbnails}</div>`;
        }
    
        const carouselHTML = `
            <div id="${carouselId}" class="carousel slide">
                <div class="carousel-inner">
                    ${carouselItems}
                </div>
                ${totalItems > 1 ? `
                    <button class="carousel-control-prev modal-button" type="button" data-bs-target="#${carouselId}" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next modal-button" type="button" data-bs-target="#${carouselId}" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>` : ''
                }
                ${thumbnails}
            </div>
        `;
    
        const $carousel = $modalBody.find('.carousel.slide');
        $carousel.length ? $carousel.replaceWith(carouselHTML) : $modalBody.append(carouselHTML);

        $modalBody.find('.thumbnail-item').on('click', function () {
            $(this).addClass('active').siblings().removeClass('active');
        });
    
        $modalBody.find('#' + carouselId).on('slid.bs.carousel', function () {
            const $carousel = $(this);
            const activeIndex = $carousel.find('.carousel-item.active').index();
        
            $carousel.find('.thumbnail-item').removeClass('active').eq(activeIndex).addClass('active');
        
            $carousel.find('.carousel-item video').each(function () {
                const $video = $(this);
                const $parentItem = $video.closest('.carousel-item');
                
                if ($parentItem.hasClass('active')) {
                    $video[0].play();
                } else {
                    $video[0].pause();
                }
            });
        });
    
        $modal.modal('show');
    });

    $('.modal').on('hide.bs.modal', function () {

        const button = $(this).find('.my-cart-btn')
        const form = $('.form-wrapper').find('#book-free-quote')

        if(button.length) $('.img-blk').find(`button[data-id="${button.data('id')}"]`).replaceWith(button)

        form.length && $('.modal-body').find('#book-free-quote').length
            ? form.replaceWith($('.modal-body').find('#book-free-quote')) 
            : $('.form-wrapper').append($('.modal-body').find('#book-free-quote'))

            $('.carousel.slide video').each(function() {
                if (!this.paused) {
                    originalPlayingVideo = this;
                    this.pause();
                }
            });
    });

    $('.img-blk').each(function () {
        const $carousel = $(this).find('.carousel.slide');
        const carouselId = $carousel.attr('id');
        if ($carousel.length && $carousel.find('.carousel-item').length > 1) {
            if (!$carousel.find('.carousel-control-prev').length) {
                $carousel.append(`
                    <button class="carousel-control-prev" type="button" data-bs-target="#${carouselId}" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                `);
            }
            if (!$carousel.find('.carousel-control-next').length) {
                $carousel.append(`
                    <button class="carousel-control-next" type="button" data-bs-target="#${carouselId}" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                `);
            }
        }
    });

    $('.carousel.slide').on('slid.bs.carousel', function() {
        const $carousel = $(this);
    
        $carousel.find('.carousel-item video').each(function() {
            const $video = $(this);
            const $parentItem = $video.closest('.carousel-item');
            
            if (!$parentItem.hasClass('active')) {
                $video[0].pause();
            } else {
                $video[0].play();
            }
        });
    });
});

